export const TOOLBAR_KIND = {
  note: 'note',
  task: 'task',
  file: 'file',
  contract: 'contract',
  sms: 'sms',
  email: 'email',
  payment: 'payment',
} as const

export type ToolbarKind = (typeof TOOLBAR_KIND)[keyof typeof TOOLBAR_KIND]

export const TOOLBAR_QUERY_KEY_PREFIX = '/api/v1/toolbar'
